<div class="minclt-menu hidden md:flex align-items-center justify-content-center relative lg:static p-2 bg-primary ">
  <div class="hidden sm:hidden md:block">
    <p-megaMenu [model]="items" class="md:flex" />
  </div>
</div>
<div class="minclt-menu-mobile row p-5 block sm:block md:hidden">
  <p-menubar [model]="itemsToMenu" />
</div>